<template>
	<nk-page class="excel-map" :commercialAccess="settings.commercialAccess" :buttons="[button_change_log]" :policyClaims="settings.policyClaims">
		<!--		<template #badges>-->
		<!--			<nk-badge system="accounting">-->
		<!--				<nk-badge-item type="system" modelValue="accounting" :title="$t(`forms.Import_From_Excel`)"></nk-badge-item>-->
		<!--			</nk-badge>-->
		<!--		</template>-->

		<div ref="upload" class="row form-container h-100 px-4 pb-4">
			<div class="steps d-sm-block d-none col-sm-4 col-12">
				<div v-for="(step, index) in steps" :key="index" :class="['step', index + 1 === steps.length ? 'last-step' : '', unlockedSteps.indexOf(step) > -1 ? 'active' : '']">
					<div @click="stepClicked(step)" class="step-marker"></div>
					<div class="step-content">
						<div class="step-title">
							<a @click="stepClicked(step)">{{ index + 1 }} - {{ $t(`import-from-excel-map.steps.${step}.title`) }}</a>
						</div>
						<div class="step-description">
							<span>{{ $t(`import-from-excel-map.steps.${step}.description`) }}</span>
						</div>
					</div>
				</div>
				<div v-if="updateTypes.includes(settings.type)" class="upload-update-mode">
					<nk-checkbox type="checkbox" :tabindex="200" :options="componentOptions.updateMode" v-model="update" />
					<p class="upload-update-text">{{ $t('import-from-excel-map.m.update-mode-warning', { name: $t(`import-from-excel-map.types.${settings.type.toLowerCase()}`) }) }}</p>
				</div>
				<div class="next-button pb-4">
					<nk-button v-if="this.currentStep !== 'result'" class="w-100" :disabled="!validateStep()" :options="componentOptions.nextButton" @click="buttonClicked" :tabindex="201"></nk-button>
					<nk-button v-if="this.currentStep === 'result'" class="w-100" :options="componentOptions.finishButton" @click="resolve()" :tabindex="201"></nk-button>
				</div>
			</div>
			<div class="w-100 d-sm-none steps-mobile-container d-block bg-white position-sticky top-0">
				<div class="steps-mobile col-sm-4 col-12 flex-wrap d-flex flex-row-reverse">
					<div v-for="(step, index) in steps" :key="index" :class="['step mt-3', index + 1 === steps.length ? 'last-step' : '', unlockedSteps.indexOf(step) > -1 ? 'active' : '']">
						<div class="step-marker" @click="stepClicked(step)"></div>
					</div>
					<div class="text-center w-100 my-4">
						<a @click="stepClicked(step)">{{ steps.indexOf(currentStep) + 1 }} - {{ $t(`import-from-excel-map.steps.${currentStep}.title`) }}</a>
					</div>
				</div>
			</div>

			<div class="col-sm-8 col-12 h-100">
				<div class="nk-card card">
					<div v-if="currentStep === 'upload'" class="uploadService upload-section slider opacity-0">
						<input id="chooseFile" type="file" ref="files" multiple accept=".xls,.xlsx" @change="fileChanged" />
						<a href="javascript:void(0)" @click="downloadSample" class="text-center">
							<icon icon="file-excel"></icon>
							{{ $t('download-sample-file') }}
						</a>
						<div class="drag-file" id="drag-area" @dragover="dragover" @dragleave.self="dragleave" @drop="drop" @click="inputClicked()">
							<div>
								<img src="../uploader/style/images/upload.png" class="uploadIcon" />
								<h3 class="drag-text">{{ $t('uploader.choose-file') }}
								</h3>
							</div>
						</div>
						<div v-if="selectedFile" class="show-progress">
							<img :src="excelIcon" alt="" class="file-icon">
							<div class="status">
								<h4 class="file-title">{{ selectedFile.name }} <i v-if="progress === 100" class="success fas fa-check-circle"></i></h4>
								<div class="progress" v-if="progress !== 100">
									<div class="progress-bar" :style="{ width: progress + '%' }"></div>
								</div>
								<h6 class="detail" v-if="progress !== 100">{{ progress.toString().toLocaleDigits() + '%' }}</h6>
							</div>
						</div>
					</div>
					<div v-if="currentStep === 'map'" class="cols w-100 position-relative map-section slider opacity-0">
						<div v-if="settings.type === ExcelTypes.FACTOR">
							<FactorHeaderImportExcel :mapSettings="settings" ref="excelExtraHeader" />
						</div>

						<div v-for="(col, index) in sysCols" :key="index" class="row m-0">
							<div class="col-12">
								<div class="d-flex text-center justify-content-around mb-2" v-if="index === 0">
									<h4>{{ $t('import-from-excel-map.sys-fields') }}</h4>
									<h4>{{ $t('import-from-excel-map.file-fields') }}</h4>
								</div>
								<nk-col-form-group class="color-gray" :label="col.value + ':'" :labelSizes="{ sm: 6, xs: 6 }" :dataSizes="{ sm: 6, xs: 6 }" :labelAligns="{ sm: 'right', md: 'right', lg: 'right' }">
									<nk-multichoice2 v-if="col.type === 'Array' || col.type === 'ObjectArray'" class="mb-2" v-model="map[col.key]" :data="headersData" :options="componentOptions.multichoiceOptions" :tabindex="index + 100" :disabled="fileCols.length === 0 ? true : null"></nk-multichoice2>
									<nk-dropdown startup v-else class="mb-2" v-model="map[col.key]" :data="headersData" :options="componentOptions.dropdownOptions" :tabindex="index + 100" :disabled="fileCols.length === 0 ? true : null"></nk-dropdown>
								</nk-col-form-group>
							</div>
						</div>
						<div v-if="settings.type === ExcelTypes.FLOATINGCENTER">
							<div v-for="(schema, index) in sortedSchemas" :set="currentSubject = schema.subject.split('_')[1].toLowerCase()" :key="schema.id" class="row m-0">
								<div class="subject-super" v-if="index > 0 && currentSubject !== sortedSchemas[index - 1].subject.split('_')[1].toLowerCase()">
									<span class="subject-title">{{ $t(`FloatingCenterGroups.${currentSubject}`) }}</span>
								</div>

								<div v-if="index === 0" class="subject-super">
									<span class="subject-title">{{ $t('import-from-excel-map.metadata') }}</span>
								</div>

								<div class="col-12">
									<nk-col-form-group class="color-gray" :label="`${schema.name}(${$t(`FloatingCenterGroups.${schema.subject.split('_')[1].toLowerCase()}`)}):`" :labelSizes="{ sm: 6, xs: 6 }" :dataSizes="{ sm: 6, xs: 6 }" :labelAligns="{ sm: 'right', md: 'right', lg: 'right' }">
										<nk-dropdown startup class="mb-2" v-model="map[`MetaData-${schema.code}`]" :data="headersData" :options="componentOptions.dropdownOptions" :tabindex="index + 100" :disabled="fileCols.length === 0 ? true : null"></nk-dropdown>
									</nk-col-form-group>
								</div>
							</div>
						</div>
						<div v-if="settings.type === ExcelTypes.CONTRACTSALARYITEM">
							<div v-for="(salaryItem, index) in salaryItems" :key="salaryItem.id" class="row m-0">

								<div v-if="index === 0" class="subject-super">
									<span class="subject-title">{{ $t('salary.item.salary-items') }}</span>
								</div>

								<div class="col-12">
									<nk-col-form-group class="color-gray" :label="salaryItem.name" :labelSizes="{ sm: 6, xs: 6 }" :dataSizes="{ sm: 6, xs: 6 }" :labelAligns="{ sm: 'right', md: 'right', lg: 'right' }">
										<nk-dropdown startup class="mb-2" v-model="map[`SalaryItem-${salaryItem.code}`]" :data="headersData" :options="componentOptions.dropdownOptions" :tabindex="index + 100" :disabled="fileCols.length === 0 ? true : null"></nk-dropdown>
									</nk-col-form-group>
								</div>
							</div>
						</div>
					</div>
					<div v-if="currentStep === 'preview'" class="cols w-100 position-relative preview-section slider opacity-0 h-100">
						<div class="row m-0 h-100">
							<div class="col-12 h-100">
								<ag-grid :options="previewTableOptions" :data="previewItems" v-model="selectedRows" tabindex="101"></ag-grid>
							</div>
						</div>
					</div>
					<div class="slider result-section opacity-0" v-if="currentStep === 'result'">
						<div v-if="settings.type === ExcelTypes.FACTOR" class="multi-state d-flex flex-column h-100">

							<div class="d-flex align-items-center">
								<nk-lottie :options="componentOptions.lottie" />
								<div class="d-flex flex-column">
									<span class="status-title">{{ $t('import-from-excel-map.save-complete') }}</span>
									<span class="status-result">{{ $t('import-from-excel-map.save-status', { success: multiStateResult.successCount, fail: multiStateResult.failedCount }) }}</span>
								</div>
							</div>

							<div class="h-100 h-grow-lock">
								<ag-grid :options="resultTableOptions" :data="multiStateResult.data" tabindex="101"></ag-grid>
							</div>


						</div>

						<div class="success d-flex" v-else-if="isSaveSucceed">
							<div class="status-animation">
								<nk-lottie :options="componentOptions.lottie" />
							</div>
							<div class="d-flex mt-3 flex-column align-items-right">
								<span class="status-title">{{ $t('import-from-excel-map.save-success') }}</span>
								<span v-if="resultCodes && resultCodes.length" class="status-result">{{ $t('import-from-excel-map.result-codes', { type: this.$t(`import-from-excel-map.types.${this.settings.type.toLowerCase()}`) }) }}: {{ resultCodes }}</span>
							</div>
						</div>
						<div class="fail d-flex flex-wrap" v-else-if="!isSaveSucceed">
							<div class="status-animation">
								<nk-lottie :options="componentOptions.lottie" />
							</div>
							<div class="status-title d-flex align-items-center">
								<span>{{ $t('import-from-excel-map.save-failed') }}</span>
							</div>
							<div class="errors-container w-100 alert alert-danger mx-3 my-2 fs-3">
								<p> {{ $t('import-from-excel-map.save-failed-body') }}</p>
								<p v-html="mapErrors"></p>
							</div>
						</div>
					</div>
				</div>
				<div class="upload-update-mode d-sm-none mt-4">
					<nk-checkbox type="checkbox" :tabindex="200" :options="componentOptions.updateMode" v-model="update" />
				</div>
				<div class="next-button d-sm-none pb-4">
					<nk-button v-if="this.currentStep !== 'result'" class="w-100" :disabled="!validateStep()" :options="componentOptions.nextButton" @click="buttonClicked" :tabindex="201"></nk-button>
					<nk-button v-if="this.currentStep === 'result'" class="w-100" :options="componentOptions.finishButton" @click="resolve()" :tabindex="201"></nk-button>
				</div>
			</div>
		</div>

	</nk-page>
</template>

<script>
	import $sc from '~/plugins/shortcut.collection.js'
	import { post } from '~/plugins/nikan-api'
	import TabOrder from '~/statics/taborder-functions'
	import Endpoints from '@nikan/endpoints'
	import _ from 'lodash'
	import { uploadHandler } from '~/plugins/uploader.js'
	import validators, { Checker } from '~/statics/validators.js'
	import ChangeLog from '~/components/form/change-log/change-log.vue'
	import { mapGetters } from 'vuex'
	import { SalaryItemActionTypes, SalaryItemFillTypes } from '~/enums/salary'
	import FactorHeaderImportExcel from './headers/factor-header-import-excel.vue'
	import { HardLoadingItem } from '../hard-loading/hard-loading'
	import { generateUUID } from '@/plugins/helper'
	import { addLoadingItem, getLoadingItem, removeLoadingItem } from '@/plugins/hard-loading'
	import { appendFormData } from "@/plugins/helper"
	import successLottie from '~/assets/lottie/success.json'
	import errorLottie from '~/assets/lottie/error.json'
	import excelIcon from '../uploader/style/images/Filetypes/excel-icon.png'

	const DEFAULTMAPINDEX = -1
	const ExcelTypes = {
		DOCUMENT: 'Document',
		FLOATINGCENTER: 'FloatingCenter',
		PRODUCT: 'Product',
		PERSONNEL: 'Personnel',
		CONTRACTSALARYITEM: 'ContractSalaryItem',
		FACTOR: 'Factor'
	}

	export default {
		modal: {
			size: 'custom',
			height: 600,
			width: 900,
			stateUID: 'excel-map',
		},
		components: {
			FactorHeaderImportExcel,
		},
		props: {
			options: { type: Object, default: () => { } },
		},
		mounted() {
			this.settings = _.merge(this.settings, this.options)
			document.querySelector('.uploadService').classList.remove('opacity-0')
			this.prepareWindow(this.$t('import-from-excel-map.title', { type: this.$t(`import-from-excel-map.types.${this.settings.type.toLowerCase()}`) }))

			if (this.settings.type === ExcelTypes.CONTRACTSALARYITEM)
				this.fillSalaryItems()
		},
		data() {
			return {
				excelIcon,
				mapErrors: [],
				selectedRows: [],
				previewItems: [],
				multiStateResult: {
					successCount: 0,
					failedCount: 0,
					data: []
				},
				savedFormDataFromPreview: null,
				isSaveSucceed: false,
				update: false,
				ExcelTypes: ExcelTypes,
				updateTypes: [ExcelTypes.PERSONNEL],
				salaryItems: [], // filled on ContractSalaryItem type
				button_change_log: {
					title: this.$t('change-log.f.change-log'),
					handle: (button, page, e) => {
						this.getChangeLog()
					},
					icon: 'scroll',
					policyClaims: 'General_ChangeLog_List',
				},
				componentOptions: {
					updateMode: {
						title: this.$t('import-from-excel-map.m.update-mode')
					},
					lottie: {
						styles: {
							width: '65px',
							height: '65px',
						},
						defaultOptions: {
							animationData: null,
							loop: false,

						}
					},
					nextButton: {
						title: this.$t('import-from-excel-map.buttons.next'),
						shortcut: $sc.find('next', 'install'),
						icon: 'arrow-left',
						beginOfGroup: true,
						isPrimary: true
					},
					finishButton: {
						title: this.$t('import-from-excel-map.buttons.finish'),
						shortcut: $sc.find('next', 'install'),
						icon: 'arrow-left',
						beginOfGroup: true,
						isPrimary: true
					},
					dropdownOptions: {
						searchable: true,
						required: true,
						remoteSearch: false,
						placeholder: this.$t('select-it'),
						display: (item) => item.value,
						clientSearch: (keyword, data) => {
							if (!keyword || typeof keyword !== 'string') return data || []

							for (const word of keyword.getWords())
								data = (data || []).filter(x => String(x.value).toLowerCase().includes(String(word).toLowerCase()))

							return data
						}
					},
					multichoiceOptions: {
						searchable: true,
						required: true,
						remoteSearch: false,
						placeholder: this.$t('select-it'),
						cleanOnMount: false,
						dropdown: {
							selectorHeight: '50%',
							selectorWidth: 400,
							display: (item) => item.value,
							component: {
								type: 'ag-grid',
								options: {
									id: this.$options.name,
									watchForSelectedChanges: true,
									rowSelection: {
										mode: 'multiRow',
										checkboxes: true,
										headerCheckbox: true
									},
									columnDefs: [
										{
											field: 'value',
											headerName: this.$t('import-from-excel-map.column-name'),
											sortable: false,
											width: 150,
											contentType: 'enum',
											valueFormatter: params => {
												return params.data.value
											}
										},
									],
									cellSelectionAggReport: false,
									sideBar: 'none',
									enterToSelect: false,
									doubleClickedToSelect: false,
									checkSelectedOnModelValueChange: true
								},
							},
							clientSearch: (keyword, data) => {
								if (!keyword || typeof keyword !== 'string') return data || []

								for (const word of keyword.getWords())
									data = (data || []).filter(x => String(x.value).toLowerCase().includes(String(word).toLowerCase()))

								return data
							}
						},
						display: (item) => item.value,
					},
				},
				unlockedSteps: ['upload'],
				currentStep: 'upload',
				currentlySelectedFileCols: [],
				settings: {
					policyClaims: '',
					commercialAccess: '',
					type: ''
				},
				progress: 0,
				sysCols: [],
				fileCols: [],
				map: {},
				selectedFile: null,
			}
		},
		computed: {
			...mapGetters({
				schemas: 'metadata/schemas'
			}),
			sortedSchemas() {
				return _.sortBy(this.schemas, ['subject'])
			},
			headersData() {
				return this.fileCols
			},
			hasPreviewStep() {
				return !!this.settings.previewSettings
			},
			steps() {
				return this.hasPreviewStep ? ['upload', 'map', 'preview', 'result'] : ['upload', 'map', 'result']
			},
			previewTableOptions() {
				return {
					id: this.$options.name,
					pagination: false,
					cellSelectionAggReport: false,
					enterToSelect: true,
					groupDisplayType: 'multipleColumns',
					rowSelection: {
						mode: 'multiRow',
						checkboxes: true,
						headerCheckbox: true,
						groupSelects: 'descendants',
						isRowSelectable: (params) => {
							return params.data?.passed === true
						}
					},
					sideBar: 'none',
					activeValidation: false,
					rowClassRules: {
						'error-row': (params) => {
							return params.data?.passed === false
						},
					},
					columnDefs: this.settings.previewSettings.columns
				}
			},
			resultTableOptions() {
				return {
					id: this.$options.name,
					pagination: false,
					cellSelectionAggReport: false,
					enterToSelect: true,
					groupDisplayType: 'multipleColumns',
					rowSelection: {
						mode: 'multiRow',
						checkboxes: false,
						headerCheckbox: false,
						groupSelects: 'descendants',
					},
					sideBar: 'none',
					activeValidation: false,
					rowClassRules: {
						'error-row': (params) => {
							return params.data?.isSuccess === false
						},
						'success-row': (params) => {
							return params.data?.isSuccess === true
						}
					},
					columnDefs: this.settings.previewSettings.columns
				}
			},
		},
		methods: {
			fillSalaryItems() {
				const wait = this.$wait(this.$el)
				post(Endpoints.getUrl('salaryItem.list'))
					.then(res => {
						this.salaryItems = res.data.items.filter(salaryItem => (salaryItem.actionType === SalaryItemActionTypes.Single || salaryItem.actionType === SalaryItemActionTypes.Display) && salaryItem.fillType === SalaryItemFillTypes.Monthly)
					})
					.finally(() => wait.end())
			},
			isEmpty(data) {

				if (data === DEFAULTMAPINDEX || data === null || data === undefined)
					return true

				return false
			},
			tryMatchFields() {
				var found
				this.sysCols.forEach(x => {
					const foundExactCol = this.fileCols.find(y => y.value === x.value)
					if (foundExactCol) {
						this.map[x.key] = foundExactCol
					} else {
						const foundFileCols = this.fileCols.filter(y => y.value.includes(x.value) && (x.key === 'Floatings' ? y.value.includes('کد') : true))
						if (x.type === 'Array' || x.type === 'ObjectArray') this.map[x.key] = foundFileCols
						else this.map[x.key] = foundFileCols[0]
					}
				})
				if (this.settings.type === this.ExcelTypes.FLOATINGCENTER) {
					for (var col of this.fileCols) {
						found = this.schemas.filter(x => x.name === col.value)
						if (found.length === 1)
							this.map[`MetaData-${found[0].code}`] = col
					}
				}
				if (this.settings.type === this.ExcelTypes.CONTRACTSALARYITEM) {
					for (var col of this.fileCols) {
						found = this.salaryItems.filter(x => x.name === col.value || x.displayName === col.value)
						if (found.length === 1)
							this.map[`SalaryItem-${found[0].code}`] = col
					}
				}
			},
			registerTabOrders() {
				TabOrder.subscribeKeys(this.grandParentType(), this)
			},
			getChangeLog() {

				var entityTitle = this.$t('change-log.f.excel-log-title', { type: this.$t(`import-from-excel-map.types.${this.settings.type.toLowerCase()}`) })

				this.showModal({
					component: ChangeLog,
					options: {
						entityId: null,
						entityType: `Import${this.settings.type}FromExcel`,
						entityTitle: entityTitle,
					},
				})
					.then((node) => { })
					.catch(() => { })
			},
			createEmptyMap() {

				var tmp = {}

				for (var col of this.sysCols)

					if (col.type === 'Array')
						tmp[col.key] = [DEFAULTMAPINDEX]
					else if (col.type === 'Number')
						tmp[col.key] = DEFAULTMAPINDEX

				return tmp
			},
			prepareFileCols(fileCols) {
				for (let index = 0; index < fileCols.length; index++) {
					fileCols[index] = {
						value: fileCols[index],
						index: index + 1
					}
				}
				return fileCols
			},
			validateStep(step = this.currentStep) {
				switch (step) {
					case 'upload':
						if (this.selectedFile && this.progress === 100)
							return true
						return false

					case 'map':
					case 'preview':
					case 'result':
						return true

					default:
						return false
				}
			},
			animationManager(currentStep, lastStep) {
				const currentStepIndex = this.steps.indexOf(currentStep)
				const lastStepIndex = this.steps.indexOf(lastStep)
				if (currentStepIndex > lastStepIndex) {
					document.querySelector(`.${lastStep}-section`).classList.add('slide-up-outside')
					this.defer(() => {
						document.querySelector(`.${currentStep}-section`).classList.add('slide-up-middle')
						document.querySelector(`.${currentStep}-section`).classList.add('opacity-1')
					}, 400) // Animation duration 0.3s
					this.defer(() => {
						document.querySelector(`.${currentStep}-section`).classList.remove('slide-down-middle')
					}, 800) // 2x Animation duration
				}
				else {
					document.querySelector(`.${lastStep}-section`).classList.add('slide-down-outside')
					this.defer(() => {
						document.querySelector(`.${currentStep}-section`).classList.add('slide-down-middle')
						document.querySelector(`.${currentStep}-section`).classList.add('opacity-1')
					}, 400) // Animation duration 0.3s
					this.defer(() => {
						document.querySelector(`.${currentStep}-section`).classList.remove('slide-down-middle')
					}, 800) // 2x Animation duration
				}
			},
			validateInputs(map) {

				var requiredFields = {}

				for (var col of this.sysCols) {

					if (col.isRequired)
						requiredFields[col.key] = validators('required')
				}

				let checker = new Checker(type => this.$t(`import-from-excel-map.fields.${type}`))
				let errors = checker.test(map, requiredFields)

				this.validationToast(errors)
				return errors.length === 0
			},
			urlGenerator(path) {
				return `${this.settings.module}.${path}`
			},
			saveMap(map, sendForPreview = false) {
				var formData = new FormData()
				formData.append('excelFile', this.selectedFile)
				formData.append('excelMapJson', JSON.stringify(map))
				formData.append('type', this.settings.type)
				formData.append('group', this.settings.group)
				formData.append('update', this.update)
				if (this.settings.documentGroup) formData.append('documentGroup', this.settings.documentGroup)

				if (sendForPreview) {
					this.savedFormDataFromPreview = null
				}

				if (this.$refs.excelExtraHeader) {
					const extraHeader = this.$refs.excelExtraHeader.getLocalData()

					if (extraHeader === false) return

					appendFormData(formData, extraHeader)
				}

				if (sendForPreview)
					this.importExcelFileForPreview(formData)
				else
					this.importExcelFile(this.hasPreviewStep ? this.savedFormDataFromPreview : formData)

			},
			importExcelFileForPreview(data) {
				var wait = this.$wait(this.$refs.upload)

				post(this.settings.previewSettings.endpoint, data, null).then((result) => {
					this.previewItems = result.data.items
					this.savedFormDataFromPreview = data
					this.goToNextStep()
				}).catch(() => {
					this.goToNextStep()
				}).finally(() => {
					wait.end()
				})
			},
			importExcelFile(data) {
				var wait = this.$wait(this.$refs.upload)

				if (this.settings.type === this.ExcelTypes.FACTOR) {
					data.append('selectedFactorExcelData', JSON.stringify(this.selectedRows))
				}

				const loadingId = generateUUID()
				if (this.settings.hasProgress) {

					data.append('fileId', loadingId)

					const hardLoadingInstance = new HardLoadingItem(this.$t('import-from-excel-map.title', { type: this.$t(`import-from-excel-map.types.${this.settings.type.toLowerCase()}`) }), 1, false, loadingId)
					addLoadingItem(hardLoadingInstance)
				}


				post(Endpoints.getUrl(this.urlGenerator('excel.import')), data, null, { silent: true })
					.then((result) => {
						this.resultCodes = result.data.resultCodes
						this.componentOptions.lottie.defaultOptions.animationData = successLottie
						this.isSaveSucceed = true
						this.goToNextStep()

						if (typeof this.settings.successHandler === 'function')
							this.settings.successHandler()

						if (this.settings.type === this.ExcelTypes.FACTOR) {
							this.multiStateResult.successCount = result.data.result.succeeded.length
							this.multiStateResult.failedCount = result.data.result.failed.length

							const succeededItems = result.data.result.succeeded.map(item => {
								item.isSuccess = true
								return item
							})

							const failedItems = result.data.result.failed.map(item => {
								item.isSuccess = false

								item.errorMessages = item.errors
								return item
							})

							this.multiStateResult.data = [...succeededItems, ...failedItems]
						}

					})
					.catch((err) => {
						this.mapErrors = err.message
						this.componentOptions.lottie.defaultOptions.animationData = errorLottie
						this.isSaveSucceed = false
						this.goToNextStep()


						if (this.settings.hasProgress) {
							const loadingItem = getLoadingItem(loadingId)
							if (loadingItem) {
								loadingItem.markComplete()
							}
						}
					})
					.finally(() => {
						wait.end()
						removeLoadingItem(loadingId)
					})
			},
			fetchSysFields() {

				var wait = this.$wait(this.$refs.upload)
				post(Endpoints.getUrl(this.urlGenerator('excel.getFields')), { type: this.settings.type, group: this.settings.group })
					.then((result) => {
						this.sysCols = result.data
						this.goToNextStep()
						this.tryMatchFields()
					})
					.catch((err) => {
					})
					.finally(() => {
						wait.end()
					})
			},
			fetchFileFields() {
				uploadHandler({ excelFile: this.selectedFile }, (event) => {
					this.progress = Math.round((100 * event.loaded) / event.total)
				}, 'excel.getHeaders')
					.then((result) => {
						this.fileCols = this.prepareFileCols(result.data)
					})
					.catch((err) => {
					})
			},
			fileChanged() {
				if (this.fileValidator()) {
					// clearing old map after file changes
					this.map = {}
					this.fetchFileFields()
				}
			},
			prepareDataForSave(data) {

				// generating empty array and adding DEFAULTMAPINDEX as index of every property
				var map = this.createEmptyMap()

				// mapping general proprties
				_.map(data, (value, key, collection) => {

					// If dropdown is selected then cleared the corresponding key is created in map but the value is null
					if (!value)
						map[key] = DEFAULTMAPINDEX

					else if (this.sysCols.findIndex(x => x.key === key && x.type === 'Array') > -1)
						map[key] = value.map(x => x = x.index)

					else if (this.sysCols.findIndex(x => x.key === key && x.type === 'Number') > -1)
						map[key] = value.index

				})


				// mapping edge cases
				switch (this.settings.type) {
					case this.ExcelTypes.PRODUCT:

						map['Barcodes'] = []
						map['Units'] = []

						data.BarcodeValue = this.isEmpty(data.BarcodeValue) ? [] : data.BarcodeValue
						data.UnitCode = this.isEmpty(data.UnitCode) ? [] : data.UnitCode

						for (let index = 0; index < data.BarcodeValue.length; index++)
							map['Barcodes'].push({
								BarcodeValue: data.BarcodeValue[index].index || DEFAULTMAPINDEX,
								BarcodeType: data.BarcodeType?.[index]?.index || DEFAULTMAPINDEX,
								BarcodePrices: data.BarcodePrices?.[index]?.index || DEFAULTMAPINDEX
							})

						for (let index = 0; index < data.UnitCode.length; index++)
							map['Units'].push({
								UnitCode: data.UnitCode[index].index || DEFAULTMAPINDEX,
								UnitRate: data.UnitRate[index].index || DEFAULTMAPINDEX,
								UnitIsPerimary: data.UnitIsPerimary[index].index || DEFAULTMAPINDEX
							})

						break

					case this.ExcelTypes.FLOATINGCENTER:
						map['MetaData'] = []

						const keys = Object.keys(data).filter(x => x.startsWith('MetaData')) || []

						for (const key of keys) {
							if (!this.isEmpty(data[key]))
								map['MetaData'].push({
									MetaDataSchemaCode: parseInt(key.split('-')[1]) || DEFAULTMAPINDEX,
									MetaDataSchemaValue: data[key].index || DEFAULTMAPINDEX,
								})
						}

					case this.ExcelTypes.CONTRACTSALARYITEM:

						map['SalaryItems'] = []

						const SalaryItemKeys = Object.keys(data).filter(x => x.startsWith('SalaryItem')) || []

						for (const key of SalaryItemKeys) {
							if (!this.isEmpty(data[key]))
								map['SalaryItems'].push({
									SalaryItemCode: (key.split('-')[1] || DEFAULTMAPINDEX).toString(),
									SalaryItemValue: data[key].index || DEFAULTMAPINDEX,
								})
						}


					case this.ExcelTypes.DOCUMENT:
					default:
						break
				}
				return map
			},
			fileValidator() {
				let file = (this.$refs.files.files || [])[0]
				if (!file)
					return false

				if (file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
					this.$toast(this.$t('uploader.format-not-supported'), { type: 'info' })
					return false
				}

				if (file.size >= 10000000) { // Check if the file size is under 10MB the file size value is in bytes
					this.$toast(this.$t('uploader.size-limit-exceeded', { size: 10000000 }), { type: 'info' })
					return false
				}
				this.selectedFile = this.$refs.files.files[0]
				return true
			},
			inputClicked() {
				document.getElementById('chooseFile').click()
			},
			dragover(event) {
				event.preventDefault()
				const dragarea = document.querySelector('#drag-area')
				dragarea.style.background = '#42a3fe'
			},
			dragleave() {
				const dragarea = document.querySelector('#drag-area')
				dragarea.style.background = 'whitesmoke'
			},
			drop(event) {
				event.preventDefault()
				this.$refs.files.files = event.dataTransfer.files
				this.fileChanged()
				const dragarea = document.querySelector('#drag-area')
				dragarea.style.background = 'whitesmoke'
			},
			stepClicked(step) {

				if (this.isSaveSucceed)
					return

				if (this.currentStep === step)
					return

				if (this.unlockedSteps.indexOf(step) === -1)
					return

				this.animationManager(step, this.currentStep)
				this.defer(() => {
					this.currentStep = step
				}, 300) // Animation duration 0.3s
			},
			goToNextStep() {
				let nextStep = this.steps[this.steps.indexOf(this.currentStep) + 1]

				if (!this.validateStep(nextStep))
					return

				if (this.unlockedSteps.indexOf(nextStep) === -1)
					this.unlockedSteps.push(nextStep)

				this.animationManager(nextStep, this.currentStep)
				this.defer(() => {
					this.currentStep = nextStep
					this.defer(() => this.registerTabOrders(), 100)
				}, 300) // Animation duration 0.5s
			},
			buttonClicked() {
				if (this.currentStep === 'upload')
					this.fetchSysFields()
				else if (this.currentStep === 'map') {

					if (!this.validateInputs(this.map))
						return

					this.saveMap(this.prepareDataForSave(this.map), this.hasPreviewStep)

				}

				else if (this.currentStep === 'preview') {
					this.saveMap(this.prepareDataForSave(this.map), false)
				}
			},
			downloadSample() {
				post(Endpoints.getUrl('download.download', `nikan-${this.options.type.toLowerCase()}-excel-sample.xlsx`), null)
					.then((res) => {
						const url = window.URL.createObjectURL(
							new Blob([res.data], { type: res.headers['content-type'] })
						)
						const a = document.createElement('a')
						a.style.display = 'none'
						a.href = url
						// the filename you want
						a.download = `nikan-${this.options.type.toLowerCase()}-excel-sample.xlsx`
						document.body.appendChild(a)
						a.click()
						window.URL.revokeObjectURL(url)
					})
					.catch((err) => { })
			},
			subscribeKeys() {
				this.$keyHandler.Subscribe({
					name: 'account-change-log',
					shortcut: $sc.find('change-log'),
					el: this.$el,
					context: this,
					handler: function (sender, e) {
						this.getChangeLog()
					},
				})
			}
		}
	}
</script>

<style lang="less">
	@import "../../styles/excel.less";
</style>